const postLogicTriggerValues = {
  equal: '==',
  lessOrEqual: '<=',
  greaterOrEqual: '>=',
  less: '<',
  greater: '>',
};

export default postLogicTriggerValues;

export const isAnyGreater = trigger =>
  trigger === postLogicTriggerValues.greaterOrEqual ||
  trigger === postLogicTriggerValues.greater;

export const isAnyLess = trigger =>
  trigger === postLogicTriggerValues.lessOrEqual ||
  trigger === postLogicTriggerValues.less;
